import React from 'react';

// Maps the target program status string (from the log) to a display verb.
// Teach-out is relevant for Eliminating and Suspending, not for Reinstating.
const ACTION_MAP = {
    Eliminated: { verb: 'Eliminating this program', showTeachout: true },
    Suspended:  { verb: 'Suspending this program',  showTeachout: true },
    Active:     { verb: 'Reinstating this program', showTeachout: false },
};

const Field = ({ label, children }) => (
    <div className="mb-3">
        <div className="text-muted small font-weight-bold">{label}</div>
        <div>{children}</div>
    </div>
);

export const ChangeStatusRequestView = ({ requestDetails, requestLogs }) => {
    // Use the latest "Program Status" log entry to reflect any mid-review edits
    // (user could change from Eliminating to Suspending before CHE acts).
    const statusEntries = (requestLogs ?? [])
        .filter(l => l.fieldName === 'Program Status')
        .sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp));

    const targetStatus = statusEntries[statusEntries.length - 1]?.newFieldValue;
    const action = ACTION_MAP[targetStatus];

    return (
        <div className="request-type-details">
            <h5 className="mb-1">Change Status Request</h5>
            <hr className="mt-2 mb-3" />

            <Field label="Program">
                <div className="border rounded p-2 bg-light d-inline-block">
                    <strong>{requestDetails.programName}</strong>
                    {requestDetails.programID
                        ? <span className="text-muted ml-2">(ID: {requestDetails.programID})</span>
                        : null}
                    {requestDetails.programStatus
                        ? <span className="text-muted ml-3">Current Status: {requestDetails.programStatus}</span>
                        : null}
                    {requestDetails.cipCode
                        ? <span className="text-muted ml-3">CIP: {requestDetails.cipCode}</span>
                        : null}
                </div>
            </Field>

            <Field label="Requested Action">
                {action
                    ? action.verb
                    : targetStatus
                        ? <span className="text-muted">Changing to {targetStatus}</span>
                        : <span className="text-muted">—</span>}
            </Field>

            {action?.showTeachout && (
                <Field label="Teach-out Required">
                    <span className="text-muted font-italic">Unknown (not yet tracked)</span>
                </Field>
            )}

            {requestDetails.additionalComments && (
                <Field label="Comments">
                    {requestDetails.additionalComments}
                </Field>
            )}
        </div>
    );
};
